import { reject, resolve } from 'redux-optimist-promise';
import { get } from 'lodash';
import createReducer from 'Store/utils/createReducer';
import type {
  PriceOfStayData,
  PriceOfStayError,
  PriceOfStayResponse,
} from 'Store/price-remote/price-of-stay/priceOfStay.helper';
import 'Store/price-remote/price-of-stay/priceOfStay.helper';
import { PRICE_OF_STAY_REQUEST, RESET_PRICE_OF_STAY } from 'Store/price-remote/constants';
type PriceOfStayRequestResolvedAction = OptimisticResolvedAction<PriceOfStayResponse>;
export type PriceOfStayState = {
  data: PriceOfStayData | null | undefined;
  error: PriceOfStayError | null | undefined;
  isLoading: boolean;
  lastRequestId: number;
  priceOfStayArgs: {};
};
const initialState: PriceOfStayState = {
  data: null,
  error: null,
  isLoading: true,
  lastRequestId: -1,
  priceOfStayArgs: {},
};
export const priceOfStayReducer = createReducer<PriceOfStayState>(initialState, {
  [PRICE_OF_STAY_REQUEST](
    state: PriceOfStayState,
    action: PriceOfStayRequestResolvedAction,
  ): PriceOfStayState {
    return {
      ...state,
      isLoading: true,
      data: null,
      lastRequestId: get(action, 'optimist.id', -1),
      priceOfStayArgs: action.payload?.args,
    };
  },

  [resolve(PRICE_OF_STAY_REQUEST)](
    state: PriceOfStayState,
    action: PriceOfStayRequestResolvedAction,
  ): PriceOfStayState {
    // If there is another request in progress
    if (get(action, 'optimist.id', -1) !== state.lastRequestId) {
      return state;
    }

    const { priceOfStay } = action.payload;

    if (priceOfStay && (priceOfStay as { errors?: unknown }).errors) {
      return {
        ...state,
        isLoading: false,
        data: null,
        error: (priceOfStay as { errors: PriceOfStayError }).errors,
      };
    }

    return { ...state, isLoading: false, data: priceOfStay as PriceOfStayData, error: null };
  },

  [reject(PRICE_OF_STAY_REQUEST)](state: PriceOfStayState): PriceOfStayState {
    return { ...state, isLoading: false };
  },

  [RESET_PRICE_OF_STAY](): PriceOfStayState {
    return initialState;
  },
});
